export enum Types {
	EXCLUIR_PARAMETROS_LOCALIDADE = '@SGU/EXCLUIR_PARAMETROS_LOCALIDADE',
	EXCLUIR_PARAMETROS_LOCALIDADE_SUCCESS = '@SGU/EXCLUIR_PARAMETROS_LOCALIDADE_SUCCESS',
	EXCLUIR_PARAMETROS_LOCALIDADE_FAILURE = '@SGU/EXCLUIR_PARAMETROS_LOCALIDADE_FAILURE',
	EXCLUIR_PARAMETROS_LOCALIDADE_CLEAR = '@SGU/EXCLUIR_PARAMETROS_LOCALIDADE_CLEAR',
}

export interface ExcluirParametrosLocalidade {
	status: number;
	data: ParametroLocalidade | null;
}

export interface ParametroLocalidade {
	status: string;
}

export interface ExcluirParametrosLocalidadeRequest {
	sigla: string;
}
